/**
 * Gate for AMC “True Price Guarantee” surfaces.
 * Handles GraphQL string booleans and raw custom-field objects.
 */
export function isPriceGuaranteeEnabled(value: unknown): boolean {
  let raw: unknown = value;
  if (raw && typeof raw === 'object' && 'value' in (raw as object)) {
    raw = (raw as { value: unknown }).value;
  }
  if (raw === true || raw === 1) return true;
  if (typeof raw === 'string') {
    const normalized = raw.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }
  return false;
}
